import { render, staticRenderFns } from "./TableProducts.vue?vue&type=template&id=5f7fb977&scoped=true&"
import script from "./TableProducts.vue?vue&type=script&lang=js&"
export * from "./TableProducts.vue?vue&type=script&lang=js&"
import style0 from "./TableProducts.vue?vue&type=style&index=0&id=5f7fb977&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7fb977",
  null
  
)

export default component.exports